import {
  IconArrowsExchange,
  IconChecklist,
  IconPackageImport,
  IconStack2,
} from "@tabler/icons-react";
import { ModuleLanding, NoteText } from "../../shell/ModuleLanding";

export function InventoryHome() {
  return (
    <ModuleLanding
      title="Inventory"
      subtitle="Stock on hand, goods in, and the movement ledger"
      tiles={[
        {
          to: "/inventory/levels",
          label: "Stock on hand",
          blurb: "What is on the shelf, and what has run low",
          icon: <IconStack2 size={21} stroke={1.6} />,
        },
        {
          to: "/inventory/stock-in",
          label: "Receive goods",
          blurb: "Book in a delivery against a supplier invoice",
          icon: <IconPackageImport size={21} stroke={1.6} />,
        },
        {
          to: "/inventory/movements",
          label: "Movement ledger",
          blurb: "Every change, why it happened and the balance after",
          icon: <IconArrowsExchange size={21} stroke={1.6} />,
        },
        {
          to: "/inventory/reconcile",
          label: "Reconciliation",
          blurb: "Check the stock figures against the ledger behind them",
          icon: <IconChecklist size={21} stroke={1.6} />,
        },
      ]}
      noteTitle="How stock moves"
      note={
        <>
          <NoteText>
            Three things change a quantity, and nothing else:{" "}
            <strong>receiving goods</strong>, which is the only way it goes up;{" "}
            <strong>generating a bill</strong>, which is the only way a sale
            takes it out; and a <strong>correction</strong> after a physical
            count.
          </NoteText>
          <NoteText>
            Placing a day order reserves nothing and confirming an order moves
            nothing, so a quantity here is what is actually on the shelf rather
            than what is left after promises. There is deliberately no way to
            type a quantity in directly — every figure is the sum of the ledger
            entries behind it, which is what makes the reconciliation check
            meaningful.
          </NoteText>
        </>
      }
    />
  );
}
